import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumberDirective } from './only-number.directive';
import { OnlyPriceDirective } from './only-price.directive';
import { OnlyDecimalDirective } from './only-decimal.directive';
import { PhoneMaskDirective } from './phone-mask.directive';
import { SpaceMaskDirective } from './space-mask.directive';
import { DragDropDirective } from './drag-drop.directive';
import { HighlightDirective } from './highlight.directive';

@NgModule({
  declarations: [
    OnlyNumberDirective,
    OnlyPriceDirective,
    OnlyDecimalDirective,
    PhoneMaskDirective,
    SpaceMaskDirective,
    DragDropDirective,
    HighlightDirective
  ],
  exports: [
    OnlyNumberDirective,
    OnlyPriceDirective,
    OnlyDecimalDirective,
    PhoneMaskDirective,
    SpaceMaskDirective,
    DragDropDirective,
    HighlightDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
